import React, { useCallback, useEffect, useRef, useState } from "react";
import * as RB from "react-bootstrap";
import { Link } from "react-router-dom";
import ReasonModal from "../ReasonModal";
import { Eye, Printer } from "iconsax-react";
import Pdf from "./Generate Pdf/Pdf";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useLoader } from "../../Loader";
import { formatAmount } from "../../Utils/comman";
import * as utils from "../../Utils/comman";

function View(props) {
  const { rowData } = props;
  console.log(rowData);
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalText, setModalText] = useState("");
  const { startLoader, stopLoader } = useLoader();

  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [cities, setCities] = useState([]);
  const handleShowModal = useCallback(
    (title, text) => () => {
      setModalTitle(title);
      setModalText(text);
      setShowModal(true);
    },
    []
  );
  const pdfContainerRef = useRef(null);

  const showPrice = rowData.po_items?.some((item) => item.price);
  const showAmount = rowData.po_items?.some((item) => item.amount);

  const getTotal = () => {
    const tableTotal = rowData.po_items.reduce(
      (sum, item) => sum + (Number(item.amount) || 0),
      0
    );

    const totalCgst = rowData.po_items.reduce(
      (sum, item) => sum + (Number(item.cgst_amt) || 0),
      0
    );
    const totalSgst = rowData.po_items.reduce(
      (sum, item) => sum + (Number(item.sgst_amt) || 0),
      0
    );
    const totalIgst = rowData.po_items.reduce(
      (sum, item) => sum + (Number(item.igst_amt) || 0),
      0
    );
    return (
      Number(tableTotal) +
      Number(totalCgst) +
      Number(totalSgst) +
      Number(totalIgst) +
      Number(rowData?.packing_charge) +
      Number(rowData?.transport_charge) +
      Number(rowData?.other_charge)
    );
  };

  const handlePdfGenerate = () => {
    startLoader();
    const container = pdfContainerRef.current;
    if (!container) return;
    startLoader();

    html2canvas(container).then((canvas) => {
      startLoader();

      const imgData = canvas.toDataURL("image/png");

      // Convert canvas dimensions to millimeters
      const canvasWidth = canvas.width * 0.264583; // Convert pixels to mm (1px = 0.264583mm)
      const canvasHeight = canvas.height * 0.264583;

      const pdf = new jsPDF({
        orientation: "p",
        unit: "mm",
        format: [canvasWidth, canvasHeight], // Match the PDF size to the canvas size
      });

      pdf.addImage(
        imgData,
        "PNG",
        0,
        0,
        canvasWidth,
        canvasHeight // Ensure it matches the calculated dimensions
      );

      pdf.save(`${rowData?.head_name}_order.pdf`);
      stopLoader();
    });
    stopLoader();
  };

  useEffect(() => {
    if (rowData) {
      fetchStates();
      fetchDistricts(rowData?.billing_state);
      fetchCities(rowData?.billing_district);
    }
  }, [rowData]);
  const fetchStates = () => {
    startLoader();
    utils
      .callAPI("get", `/state/list`)
      .then((res) => {
        setStates(res || []);
        stopLoader();
      })
      .catch(() => {
        setStates([]);
        stopLoader();
      });
  };

  const fetchDistricts = (stateId) => {
    startLoader();
    utils
      .callAPI("get", `/district/list?stateId=${stateId}`) // API to fetch districts
      .then((res) => {
        const data = Array.isArray(res) ? res : [];
        setDistricts(data);
        stopLoader();
      })
      .catch(() => {
        setDistricts([]);
        stopLoader();
      });
  };

  const fetchCities = (districtId) => {
    startLoader();
    utils
      .callAPI("get", `/city/by-district-list?districtId=${districtId}`) // API to fetch cities by district
      .then((res) => {
        const data = Array.isArray(res) ? res : [];

        setCities(data);
        stopLoader();
      })
      .catch(() => {
        setCities([]);
        stopLoader();
      });
  };

  const getStateName = (id) =>
    states?.find((item) => item.state_code === id)?.state_name || "";
  const getDistrictName = (id) =>
    districts?.find((item) => item.district_code === id)?.district_name || "";
  const getCityName = (id) =>
    cities?.find((item) => item.city_code === id)?.city_name || "";

  return (
    <>
      <div className="section-body">
        <RB.Card className="card shadow">
          <RB.Card.Header className="border-0">
            <h5>{rowData?.head_name} Order Details</h5>
            <div className="card-header-action">
              <Link
                className="btn btn-underline me-2"
                onClick={props.onBackClick}
              >
                Back
              </Link>

              <RB.Button
                className="btn ms-md-2"
                // variant="primary"
                onClick={handlePdfGenerate}
              >
                <Printer size="24" />
              </RB.Button>
            </div>
          </RB.Card.Header>
          <RB.Card.Body>
            <RB.Row className="mb-3">
              <RB.Col md={4}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Purchase Order Number
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.order_id || "-"}
                </p>
              </RB.Col>
              <RB.Col md={4}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Create By
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.created_name || "-"}
                </p>
              </RB.Col>
              {rowData?.cer_no && (
                <RB.Col md={4}>
                  <span className="text-uppercase fw-bold small text-body-secondary">
                    CER No.
                  </span>
                  <p className="fw-medium text-sm fw-semibold">
                    {rowData.cer_no || "-"}
                  </p>
                </RB.Col>
              )}
              <RB.Col md={4}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Purchase Order Date
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.order_date || "-"}
                </p>
              </RB.Col>

              <RB.Col md={4}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Delivery Date
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.delivery_date || "-"}
                </p>
              </RB.Col>
              <RB.Col md={4}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Vendor Name
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.vendor_name || "-"}
                </p>
              </RB.Col>
              <RB.Col md={4}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Vendor Company Name
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.companyName || "-"}
                </p>
              </RB.Col>
              {/* <RB.Col md={4}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Billing
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.billing_company_name || "-"}
                </p>
              </RB.Col> */}
              <RB.Col md={4}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Delivery Period
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.delivery_period || "-"}
                </p>
              </RB.Col>
              <RB.Col md={4}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Terms of Payment
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.terms_of_payment || "-"}
                </p>
              </RB.Col>
              <RB.Col md={4}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Shipping Location
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData?.location_name ||
                  rowData?.address ||
                  rowData?.city ||
                  rowData?.district ||
                  rowData?.state ||
                  rowData?.pincode
                    ? [
                        rowData.location_name,
                        rowData.address,
                        rowData.city,
                        rowData.district,
                        rowData.state,
                        rowData?.pincode,
                      ]
                        .filter(Boolean)
                        .join(", ")
                    : "-"}
                </p>
              </RB.Col>
              <RB.Col md={4}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Billing Address
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData?.billing_company_name ||
                  rowData?.billing_address ||
                  rowData?.billing_city ||
                  rowData?.billing_district ||
                  rowData?.billing_state ||
                  rowData?.billing_pincode
                    ? [
                        rowData?.billing_company_name,
                        rowData.billing_address,
                        getCityName(rowData.billing_city),
                        getDistrictName(rowData.billing_district),
                        getStateName(rowData.billing_state),
                        rowData?.billing_pincode,
                      ]
                        .filter(Boolean)
                        .join(", ")
                    : "-"}
                </p>
              </RB.Col>
              <RB.Col md={4}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Remarks
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.remarks || "-"}
                </p>
              </RB.Col>
              <RB.Col md={4}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  RM Code
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.rm_code || "-"}
                </p>
              </RB.Col>
              {/* <RB.Col md={4}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Status
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.isActive === "1" ? "Active" : "Inactive"}
                </p>
              </RB.Col> */}
            </RB.Row>
            {rowData?.po_material_inward && (
              <>
                <h6 className="mt-2">Store Manager Approval</h6>
                <hr className="hr-lg mt-1" />
                <RB.Row className="mb-3">
                  <RB.Col md={4}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Plant Location Name
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData?.po_material_inward.plant_name || "-"}
                    </p>
                  </RB.Col>
                  <RB.Col md={4}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Challan No. / Invoice No.
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData?.po_material_inward.challan || "-"}
                    </p>
                  </RB.Col>

                  <RB.Col md={4}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Remark
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      <span>{rowData.po_material_inward.remark || "-"}</span>

                      {/* {rowData?.po_material_inward?.remark ? (
                        rowData.po_material_inward.remark.split(" ").length >
                        1 ? (
                          <RB.Button
                            className="btn btn-flat"
                            onClick={handleShowModal(
                              "Store Manager Approval Remark",
                              rowData.po_material_inward.remark
                            )}
                          >
                            <Eye/>
                          </RB.Button>
                        ) : (
                          <span>{rowData.po_material_inward.remark}</span>
                        )
                      ) : (
                        <span>-</span>
                      )} */}
                    </p>
                  </RB.Col>
                </RB.Row>
              </>
            )}

            {rowData?.po_accounatant && (
              <>
                <h6 className="mt-2">Accountant Approval</h6>
                <hr className="hr-lg mt-1" />
                <RB.Row className="mb-3">
                  <RB.Col md={4}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Asset Name
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.po_accounatant.asset_name || "-"}
                    </p>
                  </RB.Col>
                  <RB.Col md={4}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Description
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.po_accounatant.description || "-"}
                    </p>
                  </RB.Col>
                  <RB.Col md={4}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Physical Location
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.po_accounatant.physical_location || "-"}
                    </p>
                  </RB.Col>
                  <RB.Col md={4}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Asset No.
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.po_accounatant.asset_no || "-"}
                    </p>
                  </RB.Col>
                  <RB.Col md={4}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Serial No.
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.po_accounatant.serial_no || "-"}
                    </p>
                  </RB.Col>
                  <RB.Col md={4}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Acquisition Date
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.po_accounatant.equisition_date || "-"}
                    </p>
                  </RB.Col>
                  <RB.Col md={4}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Acquisition Cost
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.po_accounatant.equisition_cost || "-"}
                    </p>
                  </RB.Col>
                  <RB.Col md={4}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Estimated Useful Life (Years)
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.po_accounatant.estimated_life || "-"}
                    </p>
                  </RB.Col>
                  <RB.Col md={4}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Estimated Salvage Value
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.po_accounatant.estimated_salvage || "-"}
                    </p>
                  </RB.Col>
                  <RB.Col md={4}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Year of Depreciation
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.po_accounatant.depreciation_year || "-"}
                    </p>
                  </RB.Col>
                  <RB.Col md={4}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Estimated Fixed-Declining Depreciation Value
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {rowData.po_accounatant
                        .estimate_fix_decline_depreciation_value || "-"}
                    </p>
                  </RB.Col>
                </RB.Row>
              </>
            )}
            <RB.Row>
              <RB.Col xs={12}>
                <div className="table-responsive">
                  <RB.Table striped bordered hover>
                    <thead>
                      <tr>
                        <th rowSpan="2">Select Items</th>
                        <th rowSpan="2">HSN Code</th>
                        <th rowSpan="2">No. Of Packages</th>
                        {showPrice && <th rowSpan="2">Price</th>}
                        <th rowSpan="2">Qty</th>
                        {showPrice && <th rowSpan="2">Amount</th>}
                        {showPrice && <th colSpan="2">CGST</th>}
                        {showPrice && <th colSpan="2">SGST</th>}
                        {showPrice && <th colSpan="2">IGST</th>}
                      </tr>
                      {showPrice && (
                        <tr>
                          <th>%</th>
                          <th>Amt</th>
                          <th>%</th>
                          <th>Amt</th>
                          <th>%</th>
                          <th>Amt</th>
                        </tr>
                      )}
                    </thead>
                    <tbody>
                      {rowData.po_items && rowData.po_items.length > 0 ? (
                        rowData.po_items.map((item, index) => (
                          <tr key={item.id}>
                            {/* <td>{index + 1}</td> */}
                            <td>{item.product_name || "-"}</td>
                            <td>{item.hsn_code || "-"}</td>
                            <td>{item.no_of_packages || "-"}</td>
                            {showPrice && (
                              <td>{formatAmount(item.price) || "-"}</td>
                            )}
                            <td>{`${item.qty} (${item.unit})` || "-"}</td>
                            {showAmount && <td>{formatAmount(item.amount)}</td>}

                            {showPrice && (
                              <>
                                <td>{item.cgst_per}</td>
                                <td>{formatAmount(item.cgst_amt)}</td>
                                <td>{item.sgst_per}</td>
                                <td>{formatAmount(item.sgst_amt)}</td>
                                <td>{item.igst_per}</td>
                                <td>{formatAmount(item.igst_amt)}</td>
                              </>
                            )}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="8" className="text-center">
                            No items available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </RB.Table>
                </div>
                {showPrice && (
                  <>
                    <RB.Row className="mt-3">
                      <div className="w-50 ms-auto">
                        {/* Amount */}
                        <div className="d-flex justify-content-between mb-1">
                          <span>Amount</span>
                          <input
                            type="text"
                            className="form-control w-auto"
                            value={formatAmount(
                              props.rowData.po_items.reduce(
                                (sum, item) => sum + Number(item.amount),
                                0
                              )
                            )}
                            readOnly
                          />
                        </div>
                        <div className="d-flex justify-content-between mb-1">
                          <span>Packing & Forwarding</span>
                          <input
                            type="text"
                            className="form-control w-auto"
                            value={formatAmount(rowData?.packing_charge)}
                            // value={props?.rowData?.po_items?.reduce((sum, item) => sum + (Number(item.cgstAmt) || 0), 0)}
                          />
                        </div>
                        <div className="d-flex justify-content-between mb-1">
                          <span>Transportation</span>
                          <input
                            type="text"
                            className="form-control w-auto"
                            value={formatAmount(rowData?.transport_charge)}
                          />
                        </div>
                        <div className="d-flex justify-content-between mb-1">
                          <span>Other</span>
                          <input
                            type="text"
                            className="form-control w-auto"
                            value={formatAmount(rowData?.other_charge)}
                          />
                        </div>
                        <div className="d-flex justify-content-between mb-1">
                          <span>CGST</span>
                          <input
                            type="text"
                            className="form-control w-auto"
                            value={formatAmount(
                              props?.rowData?.po_items?.reduce(
                                (sum, item) =>
                                  sum + (Number(item.cgst_amt) || 0),
                                0
                              )
                            )}
                            readOnly
                          />
                        </div>
                        <div className="d-flex justify-content-between mb-1">
                          <span>SGST</span>
                          <input
                            type="text"
                            className="form-control w-auto"
                            value={formatAmount(
                              props?.rowData?.po_items?.reduce(
                                (sum, item) =>
                                  sum + (Number(item.sgst_amt) || 0),
                                0
                              )
                            )}
                            readOnly
                          />
                        </div>
                        <div className="d-flex justify-content-between mb-1">
                          <span>IGST</span>
                          <input
                            type="text"
                            className="form-control w-auto"
                            value={formatAmount(
                              props?.rowData?.po_items?.reduce(
                                (sum, item) =>
                                  sum + (Number(item.igst_amt) || 0),
                                0
                              )
                            )}
                            readOnly
                          />
                        </div>
                        <div className="d-flex justify-content-between fw-bold">
                          <span>Total Amount</span>
                          <input
                            type="text"
                            className="form-control w-auto"
                            readOnly
                            value={formatAmount(getTotal() || 0)}
                          />
                        </div>
                      </div>
                    </RB.Row>
                  </>
                )}
              </RB.Col>
            </RB.Row>
          </RB.Card.Body>
          <Pdf pdfContainerRef={pdfContainerRef} rowData={rowData} />
        </RB.Card>
      </div>
      <ReasonModal
        show={showModal}
        onHide={() => setShowModal(false)}
        title={modalTitle}
        text={modalText}
      />
    </>
  );
}

export default View;
